<div class="mat-dialog-content-wrapper">
    <span class="close-button closable" (click)="close(true)" (keydown)="close(true)">
      <em class="icon-salir"></em>
    </span>
    <div mat-dialog-content>
      <div class="mat-dialog-content__image">
        <img [src]="assetsUrl + '/common/icons/aval-tag.svg'" alt="tag aval" class="icon-information" />
      </div>
      <div class="mat-dialog-content__title">
        <p>¿Qué es un Tag Aval?</p>
      </div>
      <div class="mat-dialog-content__text">
        <ul>
            <li>
                <img [src]="assetsUrl + '/common/icons/icon-wallet-grey.svg'" alt="icono" class="icon-information"/>
                <span>Un Tag es un <strong>identificador único</strong> que te permite recibir transferencias entre cuentas AVAL.</span>
            </li>
            <li>
                <img [src]="assetsUrl + '/common/icons/icon-money-credit.svg'" alt="icono" class="icon-information"/>
                <span><strong>Realiza transacciones</strong> de manera instantánea, segura y sin costo.</span>
            </li>
            <li>
                <img [src]="assetsUrl + '/common/icons/icon-money-coin.svg'" alt="icono" class="icon-information" />
                <span>Transfiere <strong>máximo $3.000.000.</strong></span>
            </li>
        </ul>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      class="btn btn-degraded blue"
      type="button"
      (click)="close(true)"
      id="confirm-tag-aval-dialog-button"
    >
      Entendido
    </button>
  </div>
  